import { Payment, PendingPaymentInfo } from 'Utils/types/payment'
import { CountryCode } from './countries'
import { CurrencyCode } from './currencies'

// TODO: Would be really nice to get a standard for these values in the DB ... diff casing all around
export enum InvoiceState {
  Draft = 'draft',
  Open = 'open',
  Processing = 'processing',
  Completed = 'completed',
  Preparing = 'preparing'
}

export enum EmployerPaymentStatus {
  Pending = 'PENDING',
  Sent = 'SENT',
  Complete = 'COMPLETE',
  Failed = 'FAILED'
}

export type Invoice = {
  id: number
  alternativeReimbursement: boolean // If the employer is reimbursing outside of JOON.
  isInAutoPayment: boolean
  countryCode: CountryCode
  currencyCode: CurrencyCode
  dateCreated: Date
  dueDate: Date
  employerPaymentStatus: EmployerPaymentStatus
  state: InvoiceState

  numberOfUsersReimbursed: number // How many users received benefits on this invoice.

  creditCardSurcharge?: number // Credit card fees if they paid by card.
  joonFees: number // The total amount JOON gets for this invoice.
  benefitTransferFees: number // Fee for reimbursements; fee applied to international invoices

  // processingFee + joonFees + benefitTransfersTotal + calculatedCreditCardSurcharge = totalAmount
  totalAmount: number // The amount the customer pays for this invoice.

  payments: Payment[]
}

export type EmployerAdminInvoice = Invoice & {
  benefitTransfersTotal: number // How much was transferred to recipients for this invoice.
  numberOfUsersChargedFor: number // How many users we charged for on this invoice.
  processingPaymentInfo: null | PendingPaymentInfo
  stripeChargedAmount: null | string // For international invoices, this is the amount that was charged to the customer.
  stripeInvoiceId?: string
}

export type JoonAdminInvoice = Invoice & {
  employerBusinessName: string
  employerId: number
  rosterSize: number
  exchangeRate: number
}

export type DetailedInvoice = Invoice & {
  employerBusinessName: string
  employerId: number

  processingPaymentInfo: null | PendingPaymentInfo
  stripeChargedAmount: null | string
  invoiceBenefitPrograms: InvoiceBenefitProgram[]
  userReimbursements: InvoiceUserReimbursement[]
  rosterSize: number

  // Amount info
  processingFee: number // How much JOON charges per user/invite/whichever payment model they are on.
  exchangeRate: number // exchange rate of usd to country currency
  calculatedProcessingFee: number // invoice country process fee * exchange rate
  numberOfUsersChargedFor: number // How many users we charged for on this invoice.
  benefitTransfersTotal: number // How much was transferred to recipients for this invoice.

  stripeInvoiceId?: string
  pricingDescription?: string
  stripeMetadata?: {
    serviceMonth: string
    rosterSize: number
    pricingPlan: string
    companyId: number
    reimbursementFee: string
  }

  // For JOON admin usage only
  createdAt: Date
  updatedAt: Date
}

export type LatestInvoice = Pick<Invoice, 'id' | 'dateCreated' | 'state' | 'dueDate'> & {
  alternativeReimbursement?: boolean
}

export type InvoiceBenefitProgram = {
  expenditureAllowance: number
  reimbursedAmount: number
  name: string
}

export type InvoiceUserReimbursement = {
  id: number
  amount: number
  transferUrl?: string
  status: string // TODO enum
  depositAccountPresent: boolean
  employeeName: string
  amountReceived?: number
}

export type EmployerAdminInvoiceTableRow = {
  date: Date
  payDate: Date
  state: InvoiceState
  paymentMethod: string
  joonFees: number
  benefitTransferAmount: number
  benefitTransferFees: number
  id: number
  invoice: EmployerAdminInvoice
  countryCode: CountryCode
  type: InvoiceType
  employerId: number
  stripeInvoiceId?: string
  previousPaymentFailed: boolean
}

export enum InvoiceType {
  Payroll = 'Payroll',
  JOON = 'JOON'
}
